import { render } from "./Benefit.vue?vue&type=template&id=3a0b7c86&scoped=true"
import script from "./Benefit.vue?vue&type=script&lang=js"
export * from "./Benefit.vue?vue&type=script&lang=js"

import "./Benefit.vue?vue&type=style&index=0&id=3a0b7c86&scoped=true&lang=css"

import exportComponent from "/home/runner/work/APLM/APLM/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0b7c86"]])

export default __exports__